<div class="header-navigation-back">
  <mat-icon (click)="onNavigateBack()">arrow_back</mat-icon>
  <span class="title">Shipment Documents</span>
</div>
@if (errorMessage) {
  <div  class="margin-top-md">{{ errorMessage }}</div>
}
@switch (viewType) {
  @case ('document-list-view') {
    @if (!loading && (!shipmentDocuments || shipmentDocuments.length === 0)) {
      <div
        fxFlexAlign="start"
        class="no-documents margin-top-sm padding-left-sm"
        >
        No documents uploaded
      </div>
    }
    @if (!driverHistory) {
      <div >
        <button
          mat-raised-button
          class="full-width upload-documents margin-top-sm margin-left-sm margin-right-sm"
          [disabled]="loading || shipmentDocuments.length >= 3"
          (click)="onAddNewDocument()"
          >
          +UPLOAD DOCUMENTS
        </button>
      </div>
    }
    @if (!loading && shipmentDocuments && shipmentDocuments.length > 0) {
      <mat-list
        class="margin-left-sm margin-right-sm"
        >
        <mat-divider></mat-divider>
        @for (shipmentDocument of shipmentDocuments; track shipmentDocument) {
          <mat-list-item
            (click)="onNavigateToShipmentDocument(shipmentDocument.id)"
            >
            <p mat-line>{{ shipmentDocument.type }}</p>
            <p mat-line>{{ shipmentDocument.createdDate }}</p>
            <mat-divider></mat-divider>
          </mat-list-item>
        }
      </mat-list>
    }
  }
  @case ('file-upload-view') {
    <div class="margin-top-sm margin-bottom-md">
      <button mat-raised-button [disabled]="loading" (click)="onCancelNewDocument()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        class="margin-left-md"
        [disabled]="!file || loading"
        (click)="onUploadNewDocument()"
        >
        Upload
      </button>
    </div>
    <div class="margin-bottom-sm margin-left-md">Proof of Delivery</div>
    <app-file-upload
      [reset]="resetFileSelection$"
      [disabled]="loading"
      (fileChange)="onFileChange($event)"
    ></app-file-upload>
  }
}
